<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 2H3a1 1 0 000 2h1v12a1 1 0 001 1h6v.88l-4.45 2.23a1 1 0 00-.44 1.34A1 1 0 007 22a.93.93 0 00.45-.11L11 20.12v.38a1 1 0 002 0v-.38l3.55 1.77A.93.93 0 0017 22a1 1 0 00.89-.55 1 1 0 00-.44-1.34L13 17.88V17h6a1 1 0 001-1V4h1a1 1 0 000-2zm-3 13H6V4h12z"/><path d="M10.25 12.94a.57.57 0 00.25.06.48.48 0 00.26-.07l5-3a.51.51 0 000-.86l-5-3a.54.54 0 00-.51 0 .52.52 0 00-.25.43v6a.52.52 0 00.25.44zM11 7.38l3.53 2.12L11 11.62z"/></svg>